import { BuildClass, TW_OVERFLOW_ELLIPSIS } from '../../../universal';
import { React, _ } from '../../lib';
import { HelpIcon } from './help';
import { LoadingSpinnerLarge, LoadingSpinnerSmall } from './loading';
import { CJSX, ConditionalObject } from './meta-types';
export const FormRow = (props) => (React.createElement("label", { className: BuildClass({
        'ui5-form-row': true,
        'tailwind-wrapper flex': true,
        [props.className ?? '']: true,
    }), style: { display: 'flex' } },
    React.createElement("span", { className: BuildClass({
            lbl: true,
            'flex-1 max-w-[100px] leading-9 h-9 pl-1 select-none': true,
            [TW_OVERFLOW_ELLIPSIS]: true,
            'max-w-[100px]': props.lblWidth != null,
            hidden: props.lblWidth === 0,
            [props.lblClass ?? '']: true,
        }), tabIndex: -1, style: {
            maxWidth: props.lblWidth ?? undefined,
            minWidth: props.lblWidth ?? undefined,
        }, title: props.title ?? props.lbl, onClick: props.onLabelClick }, props.lbl),
    React.createElement("span", { className: BuildClass({
            cmpt: true,
            'flex-1 leading-7 min-h-[36px] p-1': true,
            [TW_OVERFLOW_ELLIPSIS]: true,
        }) }, React.Children.map(props.children, x => {
        if (x == null) {
            return null;
        }
        if (_.isString(x) || _.isNumber(x)) {
            return x;
        }
        return React.cloneElement(x, {
            className: BuildClass({
                'w-full align-top': true,
                [x.props.className ?? '']: true,
            }),
        });
    })),
    ConditionalObject((props.showHelp ?? false) && Boolean(props.title), React.createElement("span", { className: BuildClass({
            'help-icon': true,
            'flex-1 max-w-[20px] min-w-[20px] text-center': true,
        }) },
        React.createElement(HelpIcon, { className: "inline-block w-full pt-[9px] pb-[7px] px-0", title: props.title ?? '' })))));
export const FormCmpt = (props) => (React.createElement(FormRow, { lbl: props.lbl, lblWidth: props.lblWidth, className: props.className, title: props.title, showHelp: props.showHelp }, makeCmpt(props.obj, props.field, props.children)));
export const makeCmpt = (parentComponent, stateKey, cmpt) => React.cloneElement(cmpt, {
    value: parentComponent.state[stateKey],
    onUpdate: (v) => {
        const delta = { [stateKey]: v };
        parentComponent.setState(delta);
    },
});
export const dummyFP = { value: null, onUpdate: () => undefined };
export const txt = (text) => (React.createElement("span", { title: String(text) }, text));
export const AsyncContextLoader = (props) => {
    const [ctxData, setCtxData] = React.useState(null);
    const [hasLoaded, setHasLoaded] = React.useState(false);
    React.useEffect(() => {
        console.log('Loading');
        if (!hasLoaded) {
            props.context
                .loader()
                .then(data => {
                console.log('Loaded', data);
                setCtxData(data);
                setHasLoaded(true);
            })
                .catch(err => {
                console.error('Error loading context', err);
            });
        }
    }, []);
    console.log('ctxData', ctxData);
    return (React.createElement(React.Fragment, null,
        React.createElement(CJSX, { cond: ctxData == null },
            React.createElement(CJSX, { cond: props.large !== false },
                React.createElement(LoadingSpinnerLarge, null)),
            React.createElement(CJSX, { cond: props.large === false },
                React.createElement(LoadingSpinnerSmall, null))),
        ctxData != null ? (React.createElement(props.context.context.Provider, { value: ctxData }, props.children)) : (React.createElement(React.Fragment, null))));
};
export const CreateDataModelSubsetContext = (data, keys, loader) => {
    const ctx = React.createContext(_.pick(data, keys));
    return {
        read: () => React.useContext(ctx),
        context: ctx,
        loader: async () => loader(data, keys),
        getter: () => _.pick(data, keys),
        _data: data,
        _keys: keys,
    };
};
export const LoadWithDataSubset = (ctx, cmpt, props) => {
    console.log('Rendering with data subset');
    return (React.createElement(AsyncContextLoader, { context: ctx }, React.createElement(cmpt, props)));
};
export const useResizeObserver = (el) => {
    const [rect, setRect] = React.useState(el?.getBoundingClientRect() ?? null);
    React.useEffect(() => {
        if (!el) {
            return _.noop;
        }
        const observer = new ResizeObserver(() => {
            setRect(el.getBoundingClientRect() ?? null);
        });
        observer.observe(el);
        return () => {
            observer.disconnect();
        };
    }, [el]);
    return (rect ?? {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0,
    });
};
export const GroupingBox = (props) => (React.createElement("section", { className: BuildClass([
        'inline-block relative p-2',
        'border border-[#ccc] rounded-md',
        'bg-[#fff]',
        props.className ?? '',
    ]), onClick: props.onClick },
    React.createElement("div", { className: BuildClass(['pb-2 text-[#606] font-light']) }, props.title),
    props.children));
//# sourceMappingURL=wrappers.js.map